import type { VarTypeInfo } from '../package-parser.js';

/**
 * Default vartype definitions generated from vartypes.json
 * DO NOT EDIT THIS FILE MANUALLY - it is auto-generated
 * Run 'npm run generate' to regenerate
 */
export const DEFAULT_VARTYPES: Array<VarTypeInfo> = [
    {
        id: 'aa',
        name: 'VT_UNKNOWN',
        description: 'Unknown (not initialized)',
    },
    {
        id: 'ab',
        name: 'VT_POTENTIAL',
        description: 'Measured WE voltage vs RE',
    },
    {
        id: 'ac',
        name: 'VT_POTENTIAL_CE',
        description: 'Measured CE voltage vs GND',
    },
    {
        id: 'ad',
        name: 'VT_POTENTIAL_SE',
        description: 'Measured SE voltage vs GND',
    },
    {
        id: 'ae',
        name: 'VT_POTENTIAL_RE',
        description: 'Measured RE voltage vs GND',
    },
    {
        id: 'af',
        name: 'VT_POTENTIAL_WE',
        description: 'Measured WE vs GND',
    },
    {
        id: 'ag',
        name: 'VT_POTENTIAL_WE_VS_CE',
        description: 'Measured WE voltage vs CE',
    },
    {
        id: 'ah',
        name: 'VT_POTENTIAL_S2_VS_RE',
        description: 'Measured second sense voltage vs RE',
    },
    {
        id: 'ai',
        name: 'VT_POTENTIAL_SE_VS_S2',
        description: 'Measured SE voltage vs second sense',
    },
    {
        id: 'aj',
        name: 'VT_POTENTIAL_BIPOT',
        description: 'Measured SE voltage vs second sense',
    },
    {
        id: 'as',
        name: 'VT_POTENTIAL_AIN0',
        description: 'Measured analog input 0 voltage',
    },
    {
        id: 'at',
        name: 'VT_POTENTIAL_AIN1',
        description: 'Measured analog input 1 voltage',
    },
    {
        id: 'au',
        name: 'VT_POTENTIAL_AIN2',
        description: 'Measured analog input 2 voltage',
    },
    {
        id: 'ba',
        name: 'VT_CURRENT',
        description: 'Measured WE current',
    },
    {
        id: 'bb',
        name: 'VT_CURRENT_BIPOT',
        description: 'Measured WE2 current',
    },
    {
        id: 'ca',
        name: 'VT_PHASE',
        description: 'Measured phase',
    },
    {
        id: 'cb',
        name: 'VT_IMP',
        description: 'Measured impedance',
    },
    {
        id: 'cc',
        name: 'VT_ZREAL',
        description: 'Measured real part of complex impedance',
    },
    {
        id: 'cd',
        name: 'VT_ZIMAG',
        description: 'Measured imaginary part of complex impedance',
    },
    {
        id: 'ce',
        name: 'VT_EIS_TDD_E',
        description: 'Measured RE potential Time Domain Data',
    },
    {
        id: 'cf',
        name: 'VT_EIS_TDD_I',
        description: 'Measured WE current Time Domain Data',
    },
    {
        id: 'cg',
        name: 'VT_EIS_FS',
        description: 'Sampling frequency used for EIS measurement',
    },
    {
        id: 'ch',
        name: 'VT_EIS_E_AC',
        description: 'Measured AC potential',
    },
    {
        id: 'ci',
        name: 'VT_EIS_E_DC',
        description: 'Measured DC potential',
    },
    {
        id: 'cj',
        name: 'VT_EIS_I_AC',
        description: 'Measured AC current',
    },
    {
        id: 'ck',
        name: 'VT_EIS_I_DC',
        description: 'Measured DC current',
    },
    {
        id: 'cl',
        name: 'VT_ZREAL_BIPOT',
        description: 'Measured real part of complex bipot impedance',
    },
    {
        id: 'cm',
        name: 'VT_ZIMAG_BIPOT',
        description: 'Measured imaginary part of complex bipot impedance',
    },
    {
        id: 'cn',
        name: 'VT_ZREAL_S2_VS_RE',
        description: 'Measured real part of complex second sense impedance',
    },
    {
        id: 'co',
        name: 'VT_ZIMAG_S2_VS_RE',
        description: 'Measured imaginary part of complex second sense impedance',
    },
    {
        id: 'cp',
        name: 'VT_ZREAL_SE_VS_S2',
        description: 'Measured real part of complex second sense impedance',
    },
    {
        id: 'cq',
        name: 'VT_ZIMAG_SE_VS_S2',
        description: 'Measured imaginary part of complex second sense impedance',
    },
    {
        id: 'cr',
        name: 'VT_EIS_TDD_BIPOT',
        description: 'Measured bipot current time domain data',
    },
    {
        id: 'cs',
        name: 'VT_EIS_TDD_S2_VS_RE',
        description: 'Measured S2 vs RE potential time domain data',
    },
    {
        id: 'ct',
        name: 'VT_EIS_TDD_SE_VS_S2',
        description: 'Measured SE vs S2 potential time domain data',
    },
    {
        id: 'cu',
        name: 'VT_EIS_AC_BIPOT',
        description: 'Measured AC bipot current',
    },
    {
        id: 'cv',
        name: 'VT_EIS_DC_BIPOT',
        description: 'Measured DC bipot current',
    },
    {
        id: 'cw',
        name: 'VT_EIS_AC_S2_VS_RE',
        description: 'Measured AC S2 vs RE potential',
    },
    {
        id: 'cx',
        name: 'VT_EIS_DC_S2_VS_RE',
        description: 'Measured DC S2 vs RE potential',
    },
    {
        id: 'cy',
        name: 'VT_EIS_AC_SE_VS_S2',
        description: 'Measured AC SE vs S2 potential',
    },
    {
        id: 'cz',
        name: 'VT_EIS_DC_SE_VS_S2',
        description: 'Measured DC SE vs S2 potential',
    },
    {
        id: 'da',
        name: 'VT_CELL_SET_POTENTIAL',
        description: 'Set control value for WE potential',
    },
    {
        id: 'db',
        name: 'VT_CELL_SET_CURRENT',
        description: 'Set control value for WE current',
    },
    {
        id: 'dc',
        name: 'VT_CELL_SET_FREQUENCY',
        description: 'Set value for frequency',
    },
    {
        id: 'dd',
        name: 'VT_CELL_SET_AMPLITUDE',
        description: 'Set value for ac amplitude',
    },
    {
        id: 'ea',
        name: 'VT_CHANNEL',
        description: 'The channel',
    },
    {
        id: 'eb',
        name: 'VT_TIME',
        description: 'Time in seconds',
    },
    {
        id: 'ec',
        name: 'VT_PIN_MSK',
        description: 'Binary pin bitmask, indicating which pins are high / low',
    },
    {
        id: 'ed',
        name: 'VT_TEMPERATURE',
        description: 'CPU temperature in degrees Celsius',
    },
    {
        id: 'ee',
        name: 'VT_COUNT',
        description: 'Count (e.g. number of data points)',
    },
    {
        id: 'ef',
        name: 'VT_TEMPERATURE_BOARD',
        description: 'Board temperature in degrees Celsius',
    },
    {
        id: 'eg',
        name: 'VT_DT_DE',
        description: 'Time vs potential derivative, dt/dE in s/V',
    },
    {
        id: 'ha',
        name: 'VT_CURRENT_GENERIC1',
        description: 'Generic current 1',
    },
    {
        id: 'hb',
        name: 'VT_CURRENT_GENERIC2',
        description: 'Generic current 2',
    },
    {
        id: 'hc',
        name: 'VT_CURRENT_GENERIC3',
        description: 'Generic current 3',
    },
    {
        id: 'hd',
        name: 'VT_CURRENT_GENERIC4',
        description: 'Generic current 4',
    },
    {
        id: 'ia',
        name: 'VT_POTENTIAL_GENERIC1',
        description: 'Generic potential 1',
    },
    {
        id: 'ib',
        name: 'VT_POTENTIAL_GENERIC2',
        description: 'Generic potential 2',
    },
    {
        id: 'ic',
        name: 'VT_POTENTIAL_GENERIC3',
        description: 'Generic potential 3',
    },
    {
        id: 'id',
        name: 'VT_POTENTIAL_GENERIC4',
        description: 'Generic potential 4',
    },
    {
        id: 'ja',
        name: 'VT_MISC_GENERIC1',
        description: 'Miscellaneous value 1 (reserved for user code)',
    },
    {
        id: 'jb',
        name: 'VT_MISC_GENERIC2',
        description: 'Miscellaneous value 2 (reserved for user code)',
    },
    {
        id: 'jc',
        name: 'VT_MISC_GENERIC3',
        description: 'Miscellaneous value 3 (reserved for user code)',
    },
    {
        id: 'jd',
        name: 'VT_MISC_GENERIC4',
        description: 'Miscellaneous value 4 (reserved for user code)',
    },
];
